import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center',
  },
  input: {
    width: 48,
    height: 56,
    textAlign: 'center',
    fontSize: 24,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    outline: 'none',
    '&:focus': {
      borderColor: theme.palette.primary.main,
    },
  },
  inputError: {
    borderColor: theme.palette.error.main,
  },
}))

export default useStyles
